import { Component } from "preact";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import { persistSettings } from "../../../calendar-common/helpers/settingsHelper";
import IconBellSolid from "../../../common/components/icons/IconBellSolid";
import actions from "../../actions";

class EventNotifyModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalTransition: false,
        };
        this.setModalTransition = this.setModalTransition.bind(this);
    }

    setModalTransition() {
        this.setState({
            modalTransition: true,
        });
    }

    componentDidMount() {
        if (this.props.componentDidMountAction !== undefined)
            this.props.componentDidMountAction();
    }

    toggle = () => {
        let checked = !this.state.checked;
        this.setState({ checked });
    };

    submit = () => {
        this.setModalTransition();
        setTimeout(() => {
            this.props.showEventNotifyModal(false);
            persistSettings({
                eventNotifyShown: !this.state.checked,
            });
        }, 1000);
    };

    render({ translate, showEventNotifyModal }, { checked }) {
        return (
            <div
                class={` fxs_c_notify_modal_backdrop  ${
                    this.state.modalTransition ? "fxs_slide_top" : ""
                }`}
            >
                <div
                    class={`fxs_c_notify_modal ${
                        this.state.modalTransition ? "fxs_fade_out" : ""
                    }`}
                >
                    <div class="fxs_c_notify_modal_inner">
                        <h2 className="fxs_headline_small">
                            <IconBellSolid /> {translate("Notify_You_Top")}
                        </h2>
                        <p
                            className="fxs_entryPlain_txt"
                            dangerouslySetInnerHTML={{
                                __html: translate("Notify_You_Info"),
                            }}
                        ></p>
                        <label class="fxs_txt_size_small">
                            <input
                                type="checkbox"
                                checked={checked}
                                onClick={this.toggle}
                            />
                            {translate("Dont_Show_Again")}
                        </label>
                        <button
                            type="button"
                            onClick={() => this.submit()}
                            class="fxs_btn fxs_btn_cta fxs_fRight fxs_btn_small"
                            role="button"
                        >
                            {translate("Accept")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default connectWithTranslations(actions)(EventNotifyModal);
